import { Box } from '@mui/material';
import { ReactNode } from 'react';
import {
  Root,
  StyledBodyGrey,
  StyledBodyLarge,
  StyledRadio,
  TitleContainer
  } from './RadioButtonStyle';

interface RadioButton {
  value?: string | number | boolean;
  title?: ReactNode;
  description?: ReactNode;
  jsxContent?: JSX.Element;
  checked: boolean;
  onChange: () => void;
}

function RadioButton({ title, description, jsxContent, checked, onChange, ...rest }: RadioButton) {
  return (
    <Root {...rest} onClick={onChange} checked={checked}>
      <TitleContainer>
        {title &&
          (typeof title === 'string' ? <StyledBodyLarge>{title}</StyledBodyLarge> : <>{title}</>)}
      </TitleContainer>
      {description && <StyledBodyGrey>{description}</StyledBodyGrey>}
      {jsxContent && <Box>{jsxContent}</Box>}
      <StyledRadio checked={checked} />
    </Root>
  );
}

export default RadioButton;
